import { FC } from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import { LoaderProps } from "@shared/interfaces";

import styles from "./Loader.module.scss";
import dog from "@assets/lottie/loading_dog.json";

export const Loader: FC<LoaderProps> = (props) => {
  const { className, style } = props;

  return (
    <section
      className={`${className && className} ${styles.wrapper}`}
      style={style}
    >
      <Player autoplay loop src={dog} className={styles.loader} />
    </section>
  );
};
